export type NativeNotificationPermissionStatus =
  | 'unknown'
  | 'granted'
  | 'denied'
  | 'not_determined';

export function parseNativeNotificationPermissionStatus(
  value: unknown
): NativeNotificationPermissionStatus | null {
  if (
    value === 'granted' ||
    value === 'denied' ||
    value === 'not_determined' ||
    value === 'unknown'
  ) {
    return value;
  }
  return null;
}

export function nativeOsNotificationsEnabled(status: NativeNotificationPermissionStatus): boolean {
  return status === 'granted';
}
